module.exports = __webpack_public_path__ + "img/101.2b5cfd03.png";